import React, { useState , useEffect } from "react";

import Message from "../../Message";
import SuccessRes from "./SuccessRes";
// import TabNav from "./TabNav";
import { joiErrorMessage } from "../../../extra/joiErrorMessage";
import { payRecordSchema } from "../../../../joi/shipmentSchema";
import { payRecordSetData } from "../../../../../context/api/shipment/pay-record/payRecordSetData";
// import { updateCustomerSetData } from "../../../../context/api/cutomer/update-customer/updateCustomerSetData";
import { useValidator } from "react-joi";
import { useCookies } from "react-cookie";
// Bootstrap
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import Modal from "react-bootstrap/Modal";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Spinner from "react-bootstrap/Spinner";
import { getEXRSetData } from '../../../../../context/api/settings/get-values/get-exchange-rate-add-record/getEXRSetData';

const PayRecordModal = ({ show, onHide, lang, data, setRefreshData }) => {
  const dataTranslate = require(`../../../../../translate/${lang === "AR" ? "arabic" : "english"
    }/data.json`);

  var schema = payRecordSchema(lang).schema;

  const initialMessageRes = {
    success: Boolean,
    message: String,
    isShow: false,
  };

  const initialSuccessMessage = {
    success: false,
    type: "",
    message: "",
    data: {},
  };

  const { state, setData, setExplicitField, validate, reset } =
    useValidator(schema);
  const [messageResponse, setMessageResponse] = useState(initialMessageRes);
  const [successMessage, setSuccessMessage] = useState(initialSuccessMessage);
  const [cookies] = useCookies();
  const [btnLoader, setBtnLoader] = useState(false);
  const [EXRLoading, setEXRLoading] = useState(false);
  const [EXRData, setEXRData] = useState([]);

  const payRecord = (e) => {
    e.preventDefault();

    let credintial = {};
    for (const item in state.$data) {
      if (state.$data[item] != null) {
        credintial[item] = state.$data[item];
      }
    }
    const shipment_id = data.id;

    if (state.$all_source_errors.length < 1) {
      setBtnLoader(() => true);
      return payRecordSetData(
        lang,
        setMessageResponse,
        cookies,
        credintial,
        setSuccessMessage,
        setBtnLoader,
        shipment_id
      );
    }
  };
  // console.log(state);
  // const navCards = {
  //   totalShipment: data.totalShipment,
  //   totalRemaning: data.totalRemaning,
  // };

  useEffect(() => {
    const fetch = async () => {
      setEXRData([]);
      await getEXRSetData(lang, setMessageResponse, cookies, setEXRData, setEXRLoading, setData);
    }
    if (show == true) {
      fetch();
    }
  }, [show]);

  return (
    <>
      <Message
        messageResponse={messageResponse}
        close={() => setMessageResponse(initialMessageRes)}
        lang={lang}
      />

      <Modal
        show={show}
        onHide={onHide}
        backdrop="static"
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="forget-pass-otp-form"
        dir={lang === "AR" ? "rtl" : "ltr"}
      >
        {successMessage.success ? (
          <SuccessRes
            lang={lang}
            dataTranslate={dataTranslate}
            onHide={async () => {
              await onHide();
              setSuccessMessage(initialSuccessMessage);
              setRefreshData((prev) => prev + 1);
            }}
            res={successMessage}
          />
        ) : (
          <>
            <Modal.Header className="d-flex align-items-center justify-content-center ">
              <Modal.Title
                id="contained-modal-title-vcenter"
                className="fs-2 d-flex flex-row gap-2"
              >
                <span>
                  {dataTranslate.popups.customerShipment_tab.pay_records.title}
                </span>
              </Modal.Title>
            </Modal.Header>
            {!EXRLoading ? <>
              <div className="menuLoader">
                <Spinner animation="border" variant="warning" />
              </div>
            </> : ""}
            <Modal.Body className="mx-5">
              <div dir={lang === "AR" ? "rtl" : ""}>
                {/* <TabNav data={navCards} /> */}

                <Container>
                  <Row className="mb-lg-3">
                    <Col lg={6} sm={12} className="mb-3 mb-lg-0">
                      <Form.Group>
                        <Form.Label>
                          {
                            dataTranslate.popups.customerShipment_tab.pay_records
                              .invoiceAmount
                          }
                          <span>
                            <sup style={{ color: "red" }}> *</sup>
                          </span>
                        </Form.Label>
                        <Form.Control
                          type="number"
                          onChange={(e) => {
                            setData((old) => ({
                              ...old,
                              invoiceAmount: e.target.value,
                            }));
                          }}
                          onBlur={() => setExplicitField("invoiceAmount", true)}
                        />

                        <Form.Text style={{ color: "red" }}>
                          {joiErrorMessage(state.$errors.invoiceAmount)}
                        </Form.Text>
                      </Form.Group>
                    </Col>
                    <Col lg={6} sm={12} className="mb-3 mb-lg-0">
                      <Form.Group>
                        <Form.Label>
                          {dataTranslate.popups.exports_tab.records.exchangeRateRMB}
                          <span>
                            <sup style={{ color: "red" }}> *</sup>
                          </span>
                        </Form.Label>
                        <Form.Control
                          disabled={!EXRLoading ? true : false}
                          type="number"
                          placeholder={
                            dataTranslate.popups.exports_tab.records.exchangeRateRMB_p
                          }
                          defaultValue={EXRData}
                          onChange={(e) => {
                            setData((old) => ({
                              ...old,
                              exchangeRateRMB: parseFloat(e.target.value),
                            }));
                          }}
                          onKeyUp={(e) => {
                            setData((old) => ({
                              ...old,
                              exchangeRateRMB: parseFloat(e.target.value),
                            }))
                          }}
                          onBlur={() => setExplicitField("exchangeRateRMB", true)}
                        />

                        <Form.Text style={{ color: "red" }}>
                          {joiErrorMessage(state.$errors.exchangeRateRMB)}
                        </Form.Text>
                      </Form.Group>
                    </Col>
                  </Row>
                  <Row className="mb-lg-3">
                    
                    <Col lg={6} sm={12} className="mb-3 mb-lg-0">
                      <Form.Group>
                        <Form.Label>
                          {dataTranslate.popups.exports_tab.records.payMethod.recordDate}
                          <span>
                            <sup style={{ color: "red" }}> *</sup>
                          </span>
                        </Form.Label>
                        <Form.Control
                          type="date"
                          disabled={!EXRLoading ? true : false}
                          onChange={(e) => {
                            setData((old) => ({
                              ...old,
                              recordDate: e.target.value,
                            }));
                          }}
                          onBlur={() => setExplicitField("recordDate", true)}
                        />

                        <Form.Text style={{ color: "red" }}>
                          {joiErrorMessage(state.$errors.recordDate)}
                        </Form.Text>
                      </Form.Group>
                    </Col>

                    <Col lg={6} sm={12} className="mb-3 mb-lg-0">
                      <Form.Group>
                        <Form.Label>
                          {dataTranslate.popups.exports_tab.records.notes}
                        </Form.Label>
                        <Form.Control
                          disabled={!EXRLoading  ? true : false}
                          as="textarea"
                          placeholder={
                            dataTranslate.popups.exports_tab.records.notes
                          }
                          onChange={(e) => {
                            setData((old) => ({
                              ...old,
                              NB: e.target.value,
                            }));
                          }}
                          onBlur={() => setExplicitField("NB", true)}
                        />

                        <Form.Text style={{ color: "red" }}>
                          {joiErrorMessage(state.$errors.NB)}
                        </Form.Text>
                      </Form.Group>
                    </Col>
                  </Row>
                </Container>
              </div>
            </Modal.Body>
            <Modal.Footer
              className="w-100 d-flex flex-row align-items-center"
              dir="ltr"
            >
              <div className="w-100 double-btns d-flex flex-row align-items-center justify-content-center gap-2">
                <Button
                  onClick={(e) => {
                    validate();
                    payRecord(e);
                  }}
                  disabled={btnLoader ? true : false}
                >
                  {dataTranslate.popups.customerShipment_tab.pay_records.pay}
                </Button>

                <Button
                  onClick={() => {
                    reset();
                    onHide();
                  }}
                >
                  {dataTranslate.popups.customerShipment_tab.pay_records.close}
                </Button>
              </div>
            </Modal.Footer>
          </>
        )}
      </Modal>
    </>
  );
};

export default PayRecordModal;
